import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        const isPublicVersionCheck = request.url.includes('/api/app/version');
        let currentUser = JSON.parse(sessionStorage.getItem('currentUser') as string);
        if (currentUser && currentUser.token && !isPublicVersionCheck) {
            request = request.clone({
                setHeaders: { 
                    // Authorization: `Bearer ${currentUser.token}`
                    // Upgraded MAY 8 2023 to use Correct JWT expirty Tokens for API and logins checks.
                    Authorization: `Bearer ${currentUser.api_key}`

                }
            });
        }

        return next.handle(request);
    }
}
